import ReactDOM from 'react-dom';

import './Modal.scss';
import { ModalAccessor } from './UseModalHook';

interface ModalWrapperProps {
    modalAccessor: ModalAccessor;
    children: React.ReactNode;
    className?: string;
}

export const Modal = ({ children, className, modalAccessor: { modalRef, visible } }: ModalWrapperProps) => {
    let modalClass = 'modal';
    if (className) {
        modalClass += ` ${className}`;
    }

    return visible
        ? ReactDOM.createPortal(
              <div className={modalClass}>
                  <div className="modal__overlay" />
                  <div className="modal__wrapper">
                      <div className="modal__container" role="dialog" aria-modal="true" ref={modalRef}>
                          {children}
                      </div>
                  </div>
              </div>,
              document.body
          )
        : null;
};
